module.exports = __webpack_public_path__ + "img/FR.24fd396f.svg";